import * as React from "react";
// eslint-disable-next-line spire/fenced-imports
import { IconPresentationProps } from "../Icon/Icon";

const Twitter: React.FC<IconPresentationProps> = props => {
    const { title: titleValue } = props;
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            role="img"
        >
            {titleValue && <title>{titleValue}</title>}
            <path d="M14.3 10.2 23.2 0h-2.1l-7.7 8.8L7.1 0H0l9.4 13.3L0 24h2.1l8.2-9.3 6.5 9.3H24l-9.7-13.8zm-2.9 3.2-.9-1.3L2.9 1.6h3.2l6.1 8.5.9 1.3L21 22.5h-3.2l-6.4-9.1z"></path>
        </svg>
    );
};

export default React.memo(Twitter);
